<template>
  <div>
    <h2 class="content-heading">
      <i class="si si-cup mr-5"></i> Welkom {{user.username}}!
    </h2>

    <admin-dashboard v-if="user.role === 'admin'" ></admin-dashboard>
    <order-picker-dashboard v-if="user.role === 'orderpicker'" ></order-picker-dashboard>

  </div>
</template>

<script>
import Tile from '../common/Tile'
import AdminDashboard from './AdminDashboard.vue'
import OrderPickerDashboard from './OrderPickerDashboard.vue'

export default {
  components: { Tile, AdminDashboard, OrderPickerDashboard },
  data () {
    return {
      user: this.$auth.getUser()
    }
  }
}
</script>



// WEBPACK FOOTER //
// DashboardPage.vue?2c1d85a2